import { colors } from '../../colors';
var pencilBanner = {
  bgColor: colors.pale,
  textColor: colors.charcoalGrey,
  textColorDark: colors.charcoalGrey,
  textColorLight: colors.white
};
export default pencilBanner;